// import vue modules
import account from './modules/account'
import approval from './modules/approval'
import cluster from './modules/cluster'
import dashboard from './modules/dashboard'
import document from './modules/document'
import logs from './modules/logs'
import sshkey from './modules/sshkey'
import team from './modules/team'
import workgroup from './modules/workgroup'
import review from './modules/review'

// import vue other modules
import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

// logger debug
import Loggers from '../plugins/logger'

// import vue and vuex
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// assert is production、testing or dev
const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  mutations,
  actions,
  getters,
  modules: {
    account,
    approval,
    cluster,
    dashboard,
    document,
    logs,
    sshkey,
    team,
    workgroup,
    review
  },
  strict: debug,
  plugins: debug ? [Loggers()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js